import React from 'react'

const VIZ_HEIGHT = 500

interface ContainerProps {
  className?: string
  children?: React.ReactNode
}

export const Container: React.FC<ContainerProps> = ({ className = '', children }) => (
  <div
    className={`${className} w-100 flex flex-column items-center justify-between`}
    style={{ height: VIZ_HEIGHT }}
  >
    {children}
  </div>
)
